import addToGlobalStore from "shared/redux/addToGlobalStore";
import addToGlobalAnalyticsMiddleware from "shared/redux/addToGlobalAnalyticsMiddleware";
import reducers from "./reducers";
import analyticsMiddleware from "./analyticsMiddleware";

function setupStore() {
	addToGlobalAnalyticsMiddleware(analyticsMiddleware);
	addToGlobalStore(reducers);
}

export default setupStore;



// WEBPACK FOOTER //
// ./src/routers/Desktop/Store/setup.js